/**
 * Link utilities for CTA links. Internal links open in the same tab;
 * external links use target="_blank" rel="noopener noreferrer".
 */

/**
 * Returns true if href is internal: hash-only, relative path, or same origin.
 * @param {string} href - Link URL
 * @returns {boolean}
 */
export function isInternalLink(href) {
  if (!href || typeof href !== 'string') return true;
  const s = href.trim();
  if (s === '' || s.startsWith('#')) return true;
  if (!s.includes('://')) return true;
  try {
    const url = new URL(s, typeof window !== 'undefined' ? window.location.origin : 'https://example.com');
    return typeof window !== 'undefined' ? url.origin === window.location.origin : false;
  } catch {
    return true;
  }
}

/**
 * Returns target and rel for an anchor. Internal: undefined; external: _blank + noopener noreferrer.
 * @param {string} href - Link URL
 * @returns {{ target?: string, rel?: string }}
 */
export function getLinkTargetAndRel(href) {
  if (isInternalLink(href)) {
    return {};
  }
  return { target: '_blank', rel: 'noopener noreferrer' };
}
